// extracted by mini-css-extract-plugin
export default {"label":"MUIMultiItemBox_label__mqLlL","divContainer":"MUIMultiItemBox_divContainer__Nq2HT"};